import { v1Api } from '@/api/backendApi';
import { getAuthToken } from '@/auth';

export const dismissExpirationNotice = async (): Promise<unknown> => {
  // The legacy V1 endpoint expects the auth token as a `token` form field
  // rather than reading it from the session cookie. v1Api sets
  // withCredentials, but this endpoint specifically reads the form value.
  // Preserve the historical behaviour until the backend route is updated.
  const formData = new FormData();
  formData.append('token', getAuthToken() ?? '');

  try {
    const { data } = await v1Api.post(
      'subscription/expiredNotificationDismissAction',
      formData
    );
    return data;
  } catch (err) {
    return err;
  }
};
